import { APPLICATIONS, getApplicationAccessLink } from '~/components/ApplicationUrls';

// export { MAINTENANCE_HEIGHT } from 'ui_shell/GlobalConstants';

export const MAINTENANCE_HEIGHT = 40;

export const DEFAULT_HELP_SITE_URL = 'https://help.mindtickle.com/support/home';
export const PRIVACY_POLICY_URL = 'http://www.mindtickle.com/privacy-policy';

export const URLS = {
  PROFILE: getApplicationAccessLink(APPLICATIONS.PROFILE),
  HELP_SITE: DEFAULT_HELP_SITE_URL,
};

export const MENU_KEYS = {
  HELP_SITE: 'HELP_SITE',
  GET_SUPPORT: 'GET_SUPPORT',
  CHAT_WITH_SUPPORT: 'CHAT_WITH_SUPPORT',
  GO_TO_LEARNING_SITE: 'GO_TO_LEARNING_SITE',
  SWITCH_LEARNING_SITE: 'SWITCH_LEARNING_SITE',
  LOGOUT: 'LOGOUT',
  PROFILE: 'PROFILE',
  PRIVACY_POLICY: 'PRIVACY_POLICY',
  SWITCH_DOMAIN: 'SWITCH_DOMAIN',
  ANNOUNCEMENT: 'ANNOUNCEMENT',
};

export const CONTENT_ACCESS_TABS = {
  CONTENT: 'content',
  LEARNERS: 'learner',
  ANALYTICS: 'analytics',
  REVIEWS: 'review',
  REINFORCEMENT: 'reinforcement',
  ASSET: 'asset',
  CALLAI: 'callai',
  MARKETPLACE: 'marketplace',
  DIGITAL_SALES_ROOMS: 'digital_sales_rooms',
  NONE: 'NONE',
};

export const CONTENT_ACCESS_TAB_TO_APPLICATIONS_MAP = {
  [CONTENT_ACCESS_TABS.CONTENT]: APPLICATIONS.ADMIN_DASHBOARD,
  [CONTENT_ACCESS_TABS.LEARNERS]: APPLICATIONS.LEARNERS_URL,
  [CONTENT_ACCESS_TABS.ANALYTICS]: APPLICATIONS.ANALYTICS,
  [CONTENT_ACCESS_TABS.REVIEWS]: APPLICATIONS.REVIEWS,
  [CONTENT_ACCESS_TABS.REINFORCEMENT]: APPLICATIONS.REINFORCEMENT,
  [CONTENT_ACCESS_TABS.ASSET]: APPLICATIONS.ASSET,
  [CONTENT_ACCESS_TABS.MARKETPLACE]: APPLICATIONS.PROGRAM_TEMPLATES,
  [CONTENT_ACCESS_TABS.DIGITAL_SALES_ROOMS]: APPLICATIONS.DSR,
};

export const DIVIDER = 'divider';

export const ACTIVE_TAB_MAPPING = {
  [CONTENT_ACCESS_TABS.CONTENT]: [],
  [CONTENT_ACCESS_TABS.LEARNERS]: [
    APPLICATIONS.LEARNERS_URL,
    APPLICATIONS.PROFILE_MANAGEMENT,
    APPLICATIONS.USER_DETAILS,
    APPLICATIONS.GROUP_DETAILS,
  ],
  [CONTENT_ACCESS_TABS.ANALYTICS]: [APPLICATIONS.ANALYTICS],
  [CONTENT_ACCESS_TABS.REVIEWS]: [APPLICATIONS.REVIEWS],
  [CONTENT_ACCESS_TABS.REINFORCEMENT]: [APPLICATIONS.REINFORCEMENT],
  [CONTENT_ACCESS_TABS.ASSET]: [APPLICATIONS.ASSET],
  [CONTENT_ACCESS_TABS.CALLAI]: [APPLICATIONS.CALLAI_ADMIN],
  [CONTENT_ACCESS_TABS.MARKETPLACE]: [APPLICATIONS.PROGRAM_TEMPLATES],
  [CONTENT_ACCESS_TABS.DIGITAL_SALES_ROOMS]: [APPLICATIONS.DSR],
  NONE: [
    APPLICATIONS.CONTENT_CENTER,
    APPLICATIONS.TESTING,
    APPLICATIONS.EDIT_READINESS_DASHBOARD,
    APPLICATIONS.EMAIL_LOGS,
    APPLICATIONS.AUTOMATION_SUITE,
    APPLICATIONS.AUTOMATION_RULES,
    APPLICATIONS.ADMIN_PAGES,
    APPLICATIONS.ADAPTIVE_PAGES,
    APPLICATIONS.AUDIT_LOGS,
    APPLICATIONS.ACCOUNT_SETTINGS_INTEGRATIONS,
  ],
};
